
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11","cy":"11","r":"9.8","stroke":"#282828","stroke-width":"2.4"}}),_c('circle',{attrs:{"cx":"11","cy":"11","r":"3.8","stroke":"#282828","stroke-width":"2.4"}})])
          )
        }
      }
    